import { render, staticRenderFns } from "./RemoteAutocomplete.vue?vue&type=template&id=6cf8a146&"
import script from "./RemoteAutocomplete.vue?vue&type=script&lang=js&"
export * from "./RemoteAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
})
